/* eslint-disable no-console */
import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      alias: ["/login"],
    },
    {
      path: "/servers",
      name: "servers",
      component: () => import("./views/Servers.vue"),
    },
    {
      path: "/price-guard",
      name: "price-guard",
      component: () => import("./views/PriceGuard.vue"),
    },
    {
      path: "/analytics",
      name: "analytics",

      component: () => import("./views/Analytics.vue"),
    },
    {
      path: "/applications",
      name: "applications",

      component: () => import("./views/Applications.vue"),
    },

    {
      path: "/configurations",
      name: "configurations",

      component: () => import("./views/Configurations.vue"),
    },
    {
      path: "/eventrules",
      name: "eventrules",

      component: () => import("./views/EventRules.vue"),
    },
    {
      path: "/settings",
      name: "settings",

      component: () => import("./views/Settings.vue"),
    },
    {
      path: "/trade-watcher",
      name: "TradeWatcher",

      component: () => import("./views/TradeWatcher.vue"),
    },
    {
      path: "/dashboard",
      name: "dashboard",

      component: () => import("./views/Dashboard.vue"),
    },
    {
      path: "/debugger",
      name: "Debugger",

      component: () => import("./views/Debugger.vue"),
    },
    {
      path: "/price-watcher",
      name: "PriceWatcher",

      component: () => import("./views/PriceWatcher.vue"),
    },
    // {
    //   path: "/price-analysis",
    //   name: "PriceAnalysis",

    //   component: () =>
    //     import(
    //       "./views/PriceAnalysis.vue"
    //     ),
    // },
    {
      path: "*",
      redirect: () => {
        window.location.replace(window.location.origin);
      },
    },
  ],
});
